module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_blue.a0d028a0.svg";